// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"759cdc61","453":"3fa3ea41","455":"8d2787b5","977":"294bee46"}[chunkId] + ".chunk.js";
};